// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuoteList_wrapper__3o8Tz","scrollContainer":"QuoteList_scrollContainer__2Nto3","dropZone":"QuoteList_dropZone__rDMhV"};